import React from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Dialog from '@components/shared/Dialog'

interface Props {
  title: string
  action: string
  name?: string
  signUpType?: string
}

const MustLoginDialog: React.FC<Props> = ({
  title,
  action,
  name = 'must_login',
  signUpType,
}: Props) => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const signUpParams = new URLSearchParams({ requested_uri: pathname })
  if (signUpType) {
    signUpParams.set('type', signUpType)
  }

  return (
    <Dialog name={name} title={title} maxWidth={400}>
      <p className="whitespace-normal">{t('messages.mustLogin', { action })}</p>
      <div className="flex flex-row justify-end w-full mt-4">
        <a
          title={t('action.login')}
          href={`/users/sign_in?requested_uri=${pathname}`}
          className="ml-3 btn btn-primary">
          {t('action.login')}
        </a>
        <a
          title={t('action.signUp')}
          href={`/users/sign_up?${signUpParams.toString()}`}
          className="ml-3 btn btn-secondary">
          {t('action.signUp')}
        </a>
      </div>
    </Dialog>
  )
}

export default MustLoginDialog
